<template>
  <div>
    <b-modal id="modalVodService" ref="modalVodService" :title="$t('Video on demand')" hide-footer size="lg" @shown="shown">
      <div v-if="editItem && (serviceType === 9)">
        <b-tabs pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.service_data.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.service_data.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.service_data.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.service_data.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" :disabled="editItem.service_data.links_count !== 0" v-model="editItem.periodic_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.periodic_service_data.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Duration')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.vod_service_data.duration"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.service_data.contract_type"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('IPTV system type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="typeVodList" v-model="editItem.vod_service_data.type"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Custom options')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.vod_service_data.type !== 1 && editItem.vod_service_data.type !== 0">
              <b-form-input type="text" v-model="editItem.vod_service_data.custom_data"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Media content')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.vod_service_data.type === 0">
              <b-row>
                <b-col cols="10">
                  <b-form-select :options="mediaContentList" v-model="selectMediaContent"/>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Service ID')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.vod_service_data.type === 1">
              <b-form-input type="nymber" v-model="serviceId"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Movie ID')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.vod_service_data.type === 1">
              <b-form-input type="nymber" v-model="movieId"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveVodService" @cancel="$refs.modalVodService.hide" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    serviceType: null,
    suppliertList: null,
    contractList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      serviceId: 0,
      movieId: 0,
      typeVodList: [
        {text: 'NetUP', value: 0},
        {text: 'Megogo', value: 1},
        {text: this.$i18n.t('Other'), value: 2}
      ],
      selectMediaContent: 0,
      mediaContentList: []
    }
  },
  methods: {
    async saveVodService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.editItem.vod_service_data.type === 0) {
        this.editItem.vod_service_data.media_content = this.selectMediaContent
      }
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.service_data.parent_id === 0) this.editItem.service_data.parent_id = -1
        this.editItem.service_data.link_by_default = Number(this.editItem.service_data.link_by_default)
        this.editItem.service_data.multiple_linking = Number(this.editItem.service_data.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      if (this.editItem.vod_service_data.type === 1) {
        this.editItem.vod_service_data.custom_data = 'ServiceId:' + this.serviceId + ',delay:0,additional:fasle,movieId:' + this.movieId
      }
      this.editItem.periodic_service_data.cost = Number(this.editItem.periodic_service_data.cost)
      this.editItem.vod_service_data.vod_type = this.editItem.vod_service_data.type
      this.editItem.vod_service_data.duration = Number(this.editItem.vod_service_data.duration) * 3600

      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_VOD_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_VOD_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalVodService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_data.service_id : response.data.service_id

          let invID = this.editItem.service_data.invoice_sup_id ? this.editItem.service_data.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.service_data.multiple_linking ? this.editItem.service_data.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }
        }
      })
    },
    shown () {
      this.serviceId = 0
      this.movieId = 0
      this.selectMediaContent = 0
      this.editItem.vod_service_data.duration = this.editItem.vod_service_data.duration / 3600
      if (this.editItem.vod_service_data.type === 1) {
        let str = JSON.parse(JSON.stringify(this.editItem.vod_service_data.custom_data.split(',')))
        this.serviceId = str[0].split(':')[1]
        this.movieId = str[3].split(':')[1]
      }
      this.mediaContentList = []
      if (this.$store.getters['Tariffing/MEDIA_CONTENTS']) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/MEDIA_CONTENTS']))) {
          if (el.type !== 'vod') {
            continue
          }
          el.value = el.id
          el.text = el.name
          this.mediaContentList.push(el)
        }
      }
      const mediaContent = this.mediaContentList.find((content) => { return content.id === this.editItem.vod_service_data.media_content })
      if (mediaContent) {
        this.selectMediaContent = mediaContent.id
      } else if (this.mediaContentList.length > 0) {
        this.selectMediaContent = this.mediaContentList[0].id
      }
    }
  },
  computed: {
    mediaContents () {
      return this.$store.getters['Tariffing/MEDIA_CONTENTS']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formVodService.vue